/**
 * Attribution params carried forward across navigation. The root
 * `retainSearchParams` middleware re-applies these from the current URL whenever
 * a navigation omits them, so they survive forward clicks without manual merging.
 */
export const RETAINED_SEARCH_PARAMS = ['source'] as const;

export type RetainedSearch = Partial<
	Record<(typeof RETAINED_SEARCH_PARAMS)[number], string>
>;

/**
 * `validateSearch` for the root route — picks the retained string params.
 */
export function validateRetainedSearch(
	search: Record<string, unknown>,
): RetainedSearch {
	const result: RetainedSearch = {};
	for (const key of RETAINED_SEARCH_PARAMS) {
		const value = search[key];
		if (typeof value === 'string') {
			result[key] = value;
		}
	}
	return result;
}
